// Extracted from sections/product-tabs.liquid. Scroll target comes from data-scroll-target:
// the old hardcoded template id was stale, so the scroll threw on every click.
document.addEventListener('DOMContentLoaded', function () {
  const readMoreButtons = document.querySelectorAll('#readSpecialOffer');

  readMoreButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const parentSection = this.closest('.desc_section');
      if (!parentSection) return;

      if (parentSection.classList.contains('desc_section_active')) {
        parentSection.classList.remove('desc_section_active');
        this.innerHTML = '<b>Read More</b> +';
      } else {
        parentSection.classList.add('desc_section_active');
        this.innerHTML = '<b>Read Less</b> -';
      }

      const target = this.dataset.scrollTarget;
      if (target) scroll_function('#' + target);
    });
  });
});

function scroll_function(href) {
  const target = document.querySelector(href);
  if (!target) return;
  const header = document.querySelector('.shopify-section-group-header-group');
  const headerHeight = header ? header.offsetHeight : 0;
  window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - headerHeight, behavior: 'smooth' });
}
